"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationException = void 0;
const domain_exception_1 = require("./domain.exception");
/**
 * Should be thrown when:
 * - Authentication is present
 * AND
 * - An action is attempted which for which the authenticated person does not have permission.
 */
class AuthorizationException extends domain_exception_1.DomainException {
    constructor(message, data) {
        super(message, data);
    }
}
exports.AuthorizationException = AuthorizationException;
